var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuillPen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7679_40874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.705 10.527C5.53025 10.995 5.3825 11.427 5.2505 11.8643C5.9705 11.3415 6.82625 11.01 7.814 10.8863C9.69875 10.6508 11.3735 9.4065 12.221 7.84275L11.129 6.7515L12.1888 5.69025L12.9387 4.9395C13.2612 4.617 13.625 4.0215 14.0098 3.1635C9.815 3.81375 7.24625 6.3825 5.70425 10.527H5.705ZM13.25 6.75075L14 7.5C13.25 9.75 11 12 8 12.375C5.99825 12.6255 4.748 14.0002 4.2485 16.5H2.75C3.5 12 5 1.5 16.25 1.5C15.5 3.74775 14.7515 5.247 14.0023 5.99775L13.25 6.75075Z",
    fill: "#0A2756"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7679_40874"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuillPen);
export default __webpack_public_path__ + "static/media/quill-pen.c62b0c4417618b7e18f96c8f21f4d47b.svg";
export { ForwardRef as ReactComponent };